import { getSocket } from './socket.instance';

let reconnectTimer = null;

export const connectSocket = () => {
  const socket = getSocket();
  if (!socket || socket.connected) return;

  socket.connect();
};

export const reconnectSocket = (delay = 2000) => {
  const socket = getSocket();
  if (!socket || socket.connected) return;

  if (reconnectTimer) clearTimeout(reconnectTimer);

  reconnectTimer = setTimeout(() => {
    socket.connect();
  }, delay);
};

export const destroySocket = () => {
  const socket = getSocket();
  if (!socket) return;

  if (reconnectTimer) clearTimeout(reconnectTimer);

  socket.removeAllListeners();
  socket.disconnect();
};
